const clientTypes = {
  PARCELS: "parcels",
  FULFIL: "fulfilment",
  APP: "app",
  WMS: "wms",
};

export default clientTypes;
